// ABOUTME: Purchase order email template view on the relation Email settings page.
// ABOUTME: Thin wrapper around the shared EmailTemplateEditor; the mail announces an inbound to its supplier.

import EmailTemplateEditor from "../../../../../components/global/EmailTemplates/EmailTemplateEditor";
import { UserPrivileges } from "../../../../../utils/permissions";

const PurchaseOrder = (props) => (
    <EmailTemplateEditor
        {...props}
        type="purchaseorder"
        titleKey="purchaseorder_email"
        managePrivileges={[UserPrivileges.RP_COMPANY_INFO_MANAGE]}
        showSubject
    />
);

export default PurchaseOrder;
